import type { LC, PropsWithChildren } from '@use-gpu/live';

const BATCHED_VARIANTS = () => RenderBatchDraw;

export type RenderBatchProps = PropsWithChildren<{
  then: (batch: LiveElement) => void,
}>;

export type VariantContextProps = (virtual: VirtualDraw, hovered: boolean) => LC | LC[] | null | undefined;

export const RenderBatch: LC<RenderBatchProps> = (props: RenderBatchProps) => {
  const {children, then} = props;

  return (
    reconcile(
      quote(
        provide(PassContext, passContext,
          multiGather(
            unquote(provide(VariantContext, BATCHED_VARIANTS, children)),
            Resume
          )
        )
      )
    )
  );
};

export const RenderBatchDraw = (props: VirtualDraw) => {
  return yeet(props);
};